<template>
    <div class='featured-posts border-bottom padding-bottom'>

        <div id="featured-swiper-container"
             class="swiper-container padding-top">
            <div class="swiper-wrapper">
                <dsFeaturedItem v-for='item in posts.featured'
                                :item="item"
                                :language="language"
                                :tags='tags'></dsFeaturedItem>
            </div>
        </div>

        <div class="swiper-pagination"></div>

    </div>
</template>

<script>
import dsFeaturedItem from './dsFeaturedItem'
import Swiper from 'swiper'
export default {
  name: 'dsFeatured',
  featuredPostSlideShow: {},
  components: {
    dsFeaturedItem
  },
  props: ['language', 'posts', 'tags'],
  mounted() {
    this.featuredPostSlideShow = new Swiper('#featured-swiper-container', {
      speed: 1000,
      autoplay: 8000,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      loop: true,
      spaceBetween: 30
    })
  }
}
</script>

<style lang='scss'>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';

.featured-posts {
  width: 100%;
  height: 44 * $baseline;
  position: relative;
  @include screen-size ('medium') {
    height: 25 * $baseline;
  }
  @include screen-size ('x-small') {
    height: auto;
  }
  &:hover {
  }
}
.swiper-pagination {
  transition: none !important;
  position: absolute;
  bottom: $baseline * 2;
  height: $baseline * 2 !important;
  left: 2 * $column + $margin * 2;
  @include screen-size ('medium') {
    left: 0;
    height: $baseline !important;
  }
}
.swiper-pagination-bullet {
  height: $baseline * 2 !important;
  width: $baseline * 2 !important;
  @include screen-size ('x-small') {
    height: $baseline !important;
    width: $baseline !important;
  }
  margin-right: 5px;
  opacity: 1 !important;
  background: transparent !important;
  border: 2px solid $high-light;
}
.swiper-pagination-bullet-active {
  background: $high-light !important;
}
</style>



// WEBPACK FOOTER //
// dsFeatured.vue?485f8b2c